import { profileKey } from '@staffedupusa/shared-components';
import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import { errorMessage, updateEmployerLogoRoute, updateLogoRoute } from '@features/profile';
import axiosInstance from '@server/axiosInstance';

type useUpdateEmployerProfileImageProps = {
  setAlertText?: Dispatch<SetStateAction<string>>;
};

export const useUpdateEmployerProfileImage = ({
  setAlertText = () => { },
}: useUpdateEmployerProfileImageProps) => {
  const client = useQueryClient();

  const { mutate: updateEmployerProfileImage, isLoading: isUpdatingEmployerProfileImage } =
    useMutation({
      mutationFn: (variables: { logo?: string; cover_image?: string }) =>
        axiosInstance.post(updateEmployerLogoRoute, variables).then((res) => res.data),
      onSuccess: (data) => {
        if (data.status !== 200) {
          setAlertText(data.message);
        } else {
          setAlertText('');
          client.invalidateQueries([profileKey]);
        }
      },
      onError: () => {
        setAlertText(errorMessage);
      },
    });

  return {
    updateEmployerProfileImage,
    isUpdatingEmployerProfileImage,
  };
};
